module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76mh6"))).then(() => parcelRequire('37nVf'));